import { post } from 'utils/sdk';

interface IInitiateFlightTicketsPaymentParams {
  flightTicketProposalId: number;
  selectedPaymentMethod: string;
  currency: string;
}

export const initiateFlightTicketsPayment = ({
  flightTicketProposalId,
  selectedPaymentMethod,
  currency,
}: IInitiateFlightTicketsPaymentParams) =>
  post<{ checkout_url?: string }>('api/customer-facing/initiate-payment', {
    flight_ticket_proposal_id: flightTicketProposalId,
    payment_method: selectedPaymentMethod,
    selected_currency: currency,
  });
